import { ImportDataEditStep } from "@/pages/settings/import-data/edit/import-data-edit.types.ts";
import { Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

interface ImportDataEditSidebarProps {
  step: ImportDataEditStep;
  onStepClick?: (step: ImportDataEditStep) => void;
}

export function ImportDataEditSidebar({ step, onStepClick }: ImportDataEditSidebarProps) {
  const { t } = useTranslation();

  const menuItems = [
    {
      step: ImportDataEditStep.preset,
      title: t("core:import_data_start_new"),
    },
    {
      step: ImportDataEditStep.preview,
      title: t("core:import_data_step_preview"),
    },
    {
      step: ImportDataEditStep.common_settings,
      title: t("core:import_data_step_common_settings"),
    },
    {
      step: ImportDataEditStep.match,
      title: t("core:import_data_step_match"),
    },
    {
      step: ImportDataEditStep.confirmation,
      title: t("core:import_data_step_confirmation"),
    },
  ];
  const currentStepIndex = menuItems.findIndex((item) => item.step === step);

  return (
    <Stack className={"px-6"} gap={"md"}>
      {menuItems.map((item, itemIndex) => {
        const isCurrentStep = step === item.step;
        const isClickAvailable = itemIndex < currentStepIndex;

        return (
          <Text
            key={item.step}
            className={[
              isCurrentStep ? "text-default" : "text-secondary",
              isClickAvailable ? "cursor-pointer" : "",
            ].join(" ")}
            onClick={isClickAvailable ? () => onStepClick?.(item.step) : undefined}
          >
            {item.title}
          </Text>
        );
      })}
    </Stack>
  );
}
